import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputCheckbox from '../../../../common/components/ui/InputCheckbox';
import styles from './FieldPayerIsCustomer.module.scss';

const FieldPayerIsCustomer = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-payerIsCustomer',
    defaultMessage: 'Payer is customer'
  });
  const [field, meta] = useField<boolean>({name: 'payerIsCustomer'});

  return (
    <InputCheckbox
      {...field}
      {...meta}
      id={field.name}
      label={
        <div>
          <span>{labelText}</span>
        </div>
      }
      customClassNames={{inputContainer: styles.container}}
    />
  );
};

export default FieldPayerIsCustomer;
